// extracted by mini-css-extract-plugin
export default {"loader":"Spinner_loader__ayRXQ","rotate":"Spinner_rotate__iWWYX","prixClipFix":"Spinner_prixClipFix__Yex3U"};